import {Swiper, Autoplay, EffectCards} from 'swiper';

let mySwiper;


mySwiper = new Swiper('.image-slider', {
    modules:[Autoplay, EffectCards],
    loop: false,
    effect: "cards",
    speed: 500,
    grabCursor: true,
    slideToClickedSlide: true,
    slidesPerView: "auto",
    autoplay: {
        disableOnInteraction: true,
        delay: 7000,
    },
    cardsEffect: {
        perSlideRotate: 3,
        slideShadows: false
    },
});
